var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import { Prop, Watch } from 'vue-property-decorator';
import Component from 'vue-class-component';
import StockInitService from '../../../api/StockInitService';
import EHanldeStatus from '../../../enum/EHandleStatus';
import OrderService from '../../../api/OrderService';
import CommonService from "../../../api/CommonService";
import { getDateAtZeroPoint } from '../../../helper/dateUtil';
import HeaderItem from "../../../components/HeaderItem";
var default_1 = (function (_super) {
    __extends(default_1, _super);
    function default_1() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.supplierorganOptions = [];
        _this.supplierdepotOptions = [];
        _this.billsSource = [];
        _this.organBusiness = [];
        _this.outStoreList = [];
        _this.outOrganList = [];
        _this.EHanldeStatus = EHanldeStatus;
        _this.orderDatePickerOptions = {
            disabledDate: function (time) {
                return false;
            }
        };
        _this.arrivedDatePickerOptions = {
            disabledDate: function (time) {
                return false;
            }
        };
        return _this;
    }
    default_1.prototype.watchorder_ctime = function (newValue, oldValue) {
        this.arrivedDatePickerOptions = {
            disabledDate: function (time) {
                if (newValue) {
                    var start = getDateAtZeroPoint(new Date(newValue));
                    return time.getTime() < start.getTime();
                }
                else {
                    return false;
                }
            }
        };
    };
    default_1.prototype.watchorder_arriveddate = function (newValue, oldValue) {
        this.orderDatePickerOptions = {
            disabledDate: function (time) {
                if (newValue) {
                    var end = getDateAtZeroPoint(new Date(newValue));
                    return time.getTime() > end.getTime();
                }
                else {
                    return false;
                }
            }
        };
    };
    default_1.prototype.watchorgan_id = function (newValue, oldValue) {
        var _this = this;
        if (this.handleStatus === EHanldeStatus.Edit)
            return;
        if (newValue) {
            (this.organBusiness || []).forEach(function (item) {
                item.children && item.children.forEach(function (shop) {
                    if (shop.id == newValue) {
                        _this.formData.business_id = item.id;
                        _this.formData.supplier_to_business_id = item.supplier_to_business_id;
                    }
                });
            });
        }
        else {
            this.formData.business_id = '';
            this.formData.supplier_to_business_id = '';
            this.formData.purchasing_agent = '';
            this.formData.purchasing_agent_phone = '';
            return;
        }
    };
    default_1.prototype.watchbusiness_id = function (newValue, oldValue) {
        if (this.handleStatus === EHanldeStatus.Edit)
            return;
        console.log(newValue);
        console.log(oldValue);
        if (newValue) {
            if (oldValue) {
                this.formData.organ_id = '';
                this.$emit('emptyOrderDetail');
            }
            this.getOrganList({
                supplier_to_business_id: newValue
            });
        }
        else {
            this.outStoreList = [];
            this.formData.organ_id = '';
            this.$emit('emptyOrderDetail');
            return;
        }
    };
    default_1.prototype.created = function () {
        this.service = StockInitService.getInstance();
        this.OrderService = OrderService.getInstance();
        this.commonService = CommonService.getInstance();
        this.getFromSystem();
        this.getShop({ type: 3, freeze: 0 });
    };
    default_1.prototype.mounted = function () { };
    default_1.prototype.shopSelect = function (node) {
        this.formData.purchasing_agent = node.shop_contact;
        this.formData.purchasing_agent_phone = node.shop_phone;
    };
    default_1.prototype.getFromSystem = function () {
        var _this = this;
        this.OrderService.getFromSystem().then(function (res) {
            _this.billsSource = res.data.data || [];
        });
    };
    default_1.prototype.getShop = function (params) {
        var _this = this;
        params = params ? params : {
            type: 1
        };
        if (this.formData.from_system) {
            params.from_system = this.formData.from_system;
        }
        this.commonService.getShopFilter(params).then(function (res) {
            if (res.data.success) {
                var depot = res.data.data;
                if (params.type == 2) {
                    _this.formData.business_id = depot[0].id;
                    _this.formData.shop_id = depot[0].children[0].id;
                }
                _this.organBusiness = depot;
            }
            else {
                _this.$message.error(res.data.msg);
            }
        }).catch(function (err) {
            _this.$message.error(err.message || err.msg);
        });
    };
    default_1.prototype.getOrganDepot = function (data) {
        var _this = this;
        this.commonService.getDepotList({
            is_init: 1
        }).then(function (res) {
            _this.outStoreList = res.data.data || [];
            _this.formData.depot_id = '';
            if (_this.outStoreList.length) {
                _this.formData.depot_id = _this.outStoreList[0].depot_id;
            }
        }).catch(function (err) {
            _this.$message.error(err.message || err.msg);
        });
    };
    default_1.prototype.changeStockType = function () {
        if (this.formData.stock_type == 2) {
            this.$emit('emptyOrderDetail');
        }
    };
    default_1.prototype.getSupplierorganOptions = function () {
        var _this = this;
        this.service.getSupplierorganOptions().then(function (res) {
            if (res.data.success) {
                _this.supplierorganOptions = res.data.data;
                if (_this.handleType == 0) {
                    _this.formData.organ_id = res.data.data && res.data.data[0] ? res.data.data[0].organ_id : '';
                }
                _this.getSupplierdepotOptions();
            }
        });
    };
    default_1.prototype.getSupplierdepotOptions = function () {
        var _this = this;
        var params = {
            organ_id: this.formData.organ_id,
            type: 1,
            is_init: 0
        };
        this.service.getSupplierdepotOptions(params).then(function (res) {
            if (res.data.success) {
                _this.supplierdepotOptions = res.data.data;
                if (_this.handleType == 0) {
                    _this.formData.depot_id = res.data.data && res.data.data[0] ? res.data.data[0].depot_id : '';
                }
            }
        });
    };
    default_1.prototype.changeOrganId = function (rec) {
        this.formData.shop_id = '';
        this.formData.business_id = '';
        this.formData.supplier_to_business_id = '';
        this.formData.organ_id = '';
        this.formData.purchasing_agent = '';
        this.formData.purchasing_agent_phone = '';
        this.outOrganList = [];
        this.getShop({ type: 3, freeze: 0, from_system: this.formData.from_system });
        this.$emit('emptyOrderDetail');
        this.getSupplierdepotOptions();
    };
    default_1.prototype.normalizer = function (node) {
        return {
            id: node.id,
            label: node.name,
            children: node.children,
        };
    };
    default_1.prototype.getOrganList = function (data) {
        var _this = this;
        var params = {
            supplier_to_business_id: data.supplier_to_business_id
        };
        return this.commonService.getOrganList(params).then(function (res) {
            var data = res.data.data;
            _this.outOrganList = data || [];
            if (_this.outOrganList.length) {
                if (!_this.formData.organ_id)
                    _this.formData.organ_id = _this.outOrganList[0].organ_id;
            }
            else {
                _this.$message.warning('请先将客户与分支机构绑定后再下单');
            }
        });
    };
    Object.defineProperty(default_1.prototype, "filteredBillsSource", {
        get: function () {
            return this.billsSource.filter(function (item) { return item.id === 4 || item.id === 5; });
        },
        enumerable: true,
        configurable: true
    });
    __decorate([
        Prop({
            required: true
        })
    ], default_1.prototype, "formData", void 0);
    __decorate([
        Prop({
            required: true,
            type: Number
        })
    ], default_1.prototype, "handleStatus", void 0);
    __decorate([
        Prop({
            required: true,
            type: Number
        })
    ], default_1.prototype, "handleType", void 0);
    __decorate([
        Watch("formData.order_ctime", { immediate: true })
    ], default_1.prototype, "watchorder_ctime", null);
    __decorate([
        Watch("formData.order_arriveddate", { immediate: true })
    ], default_1.prototype, "watchorder_arriveddate", null);
    __decorate([
        Watch("formData.shop_id")
    ], default_1.prototype, "watchorgan_id", null);
    __decorate([
        Watch("formData.supplier_to_business_id")
    ], default_1.prototype, "watchbusiness_id", null);
    default_1 = __decorate([
        Component({
            components: {
                HeaderItem: HeaderItem
            }
        })
    ], default_1);
    return default_1;
}(Vue));
export default default_1;
